export default "__VITE_ASSET__DC_IoB6X__"